import type { TipsContent } from "@/app/components/Tips";

const affiliations: TipsContent = {
	summary:
		"Including your affiliations in your CV can be helpful in showing your involvement and dedication to your profession or field.",
	tips: [
		{
			text: "Only include affiliations that are relevant to your career or field of study.",
			items: ["Professional associations", "Industry groups", "Academic organizations"],
		},
		"If you have multiple affiliations, order them by importance. For example, if you are a member of a national association and a local chapter, list the national association first.",
		"Include the dates you joined and left each affiliation to show your level of involvement.",
		"Provide details on your involvement with each affiliation, such as any leadership positions held, committees served on, or events attended.",
		"If you received any awards or recognition from your affiliations, be sure to include them in your CV.",
	],
};

export default affiliations;
